const PREVIEW_RELOAD_KEY = "preview_reloaded_for_logout";

function clearPreviewAuthState() {
    localStorage.removeItem("id_token_client");
    localStorage.removeItem("id_token");
    localStorage.removeItem("user");
    localStorage.removeItem("adminLoggedIn");
    localStorage.removeItem("cart");
    localStorage.removeItem("vuex");
    localStorage.removeItem("v_session");
}

/**
 * First visit with ?preview=true clears auth and reloads before Vue mounts,
 * so in-flight API calls are never started (avoids "Request aborted" errors).
 */
export function reloadForPreviewIfNeeded() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("preview") !== "true") {
        return false;
    }
    if (sessionStorage.getItem(PREVIEW_RELOAD_KEY)) {
        return false;
    }

    clearPreviewAuthState();
    sessionStorage.setItem(PREVIEW_RELOAD_KEY, "true");
    window.location.reload();
    return true;
}
